module.exports = __webpack_public_path__ + "9a8f55d827beaf4b2a6c4adea1ef52c9.html";


//////////////////
// WEBPACK FOOTER
// ./src/portal/states/company/sharing-center/shared-accounts/shared-accounts.html
// module id = 1851
// module chunks = 0